const constants = {
    ACCES_STOKEN: 'accessToken',
    REFRESH_STOKEN: 'refreshToken'
}

export default constants;